import { Box, Text } from '@chakra-ui/react'

import EditItemImage from 'src/components/widgets/EditItemImage/EditItemImage'
import Input from 'src/components/widgets/Input/Input'
import VoiceTipRecorder from 'src/components/widgets/VoiceTipRecorder/VoiceTipRecorder'
import { MAX_LG_INPUT, MAX_LG_INPUT_NO_COUNTER } from 'src/lib/constants'

import { TypeBuilderProps } from '../..'
import OnlyAvailableOnItList from '../../OnlyAvailableOnItList/OnlyAvailableOnItList'
import Scraper from '../../Scraper/Scraper'

const Body: React.FC<Omit<TypeBuilderProps, 'onUpdate' | 'item'>> = ({
  voiceTipRecorderProps,
  itemId,
}) => {
  return (
    <Box mt={4} w="full">
      <Box mb={2}>
        <Input
          name="url"
          type="url"
          placeholder="Content URL"
          maxLength={2000}
          w="100%"
          data-testid="contentBuilder-contentURL"
        ></Input>
      </Box>
      <Text as="h5" className="thick" mt={12} mb={4}>
        About Content
      </Text>
      <Input
        clearable
        w="full"
        name="title"
        placeholder="Title"
        data-testid="contentBuilder-title"
        withCounter={true}
        maxLength={MAX_LG_INPUT}
        hideCounterMax={MAX_LG_INPUT_NO_COUNTER}
      />
      <EditItemImage
        name="content.coverUrl"
        borderRadius={12}
        assetType="itListItemCover"
        assetId={itemId}
        width={350}
        height={350}
      />
      <VoiceTipRecorder
        name="hasVoiceTip"
        mt={4}
        title="Voice Tip"
        subtitle="Optional"
        showProfileImage={true}
        {...voiceTipRecorderProps}
      />
      <Text color="stone" m={4} mt={2} className="body-extra-small">
        Helpful context boosts conversions.
      </Text>
      <OnlyAvailableOnItList name="content.onlyAvailableOnItList" />
    </Box>
  )
}

const Builder: React.FC<TypeBuilderProps> = ({
  index,
  itemId,
  voiceTipRecorderProps,
}) => {
  return (
    <Scraper>
      <Body
        index={index}
        itemId={itemId}
        voiceTipRecorderProps={voiceTipRecorderProps}
      />
    </Scraper>
  )
}

export default Builder
